<template>
  <b-container fluid>
    <loader watch="zones">
      <div class="form-view col-xl-8">
        <b-alert v-for="input in inputsErrors" :key="input.code" dismissible show variant="danger">
          <span> {{ input.details }} </span>
        </b-alert>
        <b-row>
          <b-col>
            <h2>{{ title }}</h2>
          </b-col>
        </b-row>
        <b-form ref="form" lazy-validation novalidate @submit.prevent="submit">
          <b-form-group label="Name">
            <b-form-input v-model="zoneForm.name" />
          </b-form-group>
          <b-form-group
            v-if="!(zone && zone.code)"
            label="Code"
            :class="{ 'form-group--error': $v.zoneForm.code.$error }"
          >
            <b-form-input
              v-model="zoneForm.code"
              name="licence-area-code"
              @input="handleInputField('code')"
            />
            <ValidationMessage v-show="!$v.zoneForm.code.required" message="Code is required" />
            <ValidationMessage
              v-show="!$v.zoneForm.code.isServerSideValid"
              :message="$v.zoneForm.code.invalidMessage"
            />
          </b-form-group>
          <b-form-group class="form-group__buttons">
            <router-link class="btn btn-link" variant="link" :to="{ name: 'zonesList' }">
              Cancel
            </router-link>
            <b-button type="submit" :disabled="$v.zoneForm.$invalid" variant="rounded">
              Save
              <Icon name="save" />
            </b-button>
          </b-form-group>
        </b-form>
      </div>
    </loader>
  </b-container>
</template>

<script>
import merge from 'lodash/merge';
import forOwn from 'lodash/forOwn';
import camelCase from 'lodash/camelCase';
import { required } from '@/lib/vuelidate-custom-validators';

const ERRORS = {
  taken(inputName) {
    return `${inputName} is already taken`;
  }
};
export default {
  name: 'ZoneForm',
  props: {
    title: String,
    mainError: String,
    inputsErrors: Array,
    zone: Object,
    zoneCode: String
  },
  data() {
    return {
      error: this.mainError,
      responseErrors: [],
      zoneForm: {
        name: '',
        code: ''
      }
    };
  },
  validations() {
    if (this.inputsErrors && this.inputsErrors.length) {
      const fieldsToValidate = { zoneForm: {} };

      forOwn(this.zoneForm, (val, key) => {
        fieldsToValidate.zoneForm[key] = {
          isServerSideValid: () => this.responseErrors.indexOf(key) === -1
        };
        return true;
      });
      merge(fieldsToValidate.zoneForm.code, { required });

      return fieldsToValidate;
    }

    return {
      zoneForm: {
        code: { required }
      }
    };
  },
  watch: {
    zone(value) {
      this.updateZoneData(value);
    },
    mainError(value) {
      this.error = value;
    },
    inputsErrors(errors) {
      errors.forEach(error => this.addErrorToInput(error));
    }
  },
  mounted() {
    this.updateZoneData(this.zone);
  },
  destroyed() {
    this.$store.commit('zones/resetStore');
  },
  methods: {
    updateZoneData(zone) {
      if (zone) {
        this.zoneForm = zone;
      }
    },
    removeResponseErrors() {
      if (this.responseErrors.length > 0) {
        this.responseErrors = [];
        this.$v.$reset();
      }

      if (this.error) {
        this.error = '';
      }
    },
    handleInputField(fieldName) {
      const input = this.$v.zoneForm[fieldName];

      this.removeResponseErrors(fieldName);
      input.$touch();
    },
    errorMessage(inputName, errorCode) {
      const generateErrorMessage = ERRORS[errorCode];
      if (typeof generateErrorMessage === 'function') {
        return generateErrorMessage(inputName);
      }
      return null;
    },
    addErrorToInput(error) {
      const [, inputName, errorCode] = error.code.match(/(.*)\.(.*)/);
      const convertedInputName = camelCase(inputName);
      const input = this.$v.zoneForm[convertedInputName];

      if (input) {
        const errorMessage = this.errorMessage(convertedInputName, errorCode) || error.details;

        this.responseErrors.push(convertedInputName);
        input.invalidMessage = errorMessage;
        input.$touch();
      }
    },
    submit() {
      this.$emit('submit', {
        ...this.zoneForm
      });
    }
  }
};
</script>
